// =============================
// Imports
// =============================

import { Component } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from '../../../config/i18n';

import * as pth from '../../../helpers/proptypes';

import { DropdownList } from '../../presentationals/dropdown';

// =============================
// Component
// =============================

class DownloadArchiveButton extends Component {
  static propTypes = {
    /** Action to download high quality archive. */
    downloadHighQ: PropTypes.func,
    /** Action to download high quality archive with versions. */
    downloadHighQWithVersions: PropTypes.func,
    /** Action to download low quality archive. */
    downloadLowQ: PropTypes.func,
    /** Action to download low quality archive with versions. */
    downloadLowQWithVersions: PropTypes.func,
    /** Dropdown placement. */
    placement: pth.dropdownPlacement,
    /** Translation strings. */
    t: PropTypes.func.isRequired,
    /** Toggler element */
    togglerElement: PropTypes.node.isRequired,
  };

  static defaultProps = {
    downloadHighQ: null,
    downloadHighQWithVersions: null,
    downloadLowQ: null,
    downloadLowQWithVersions: null,
    placement: 'bottom',
  };

  render() {
    const {
      downloadHighQ,
      downloadHighQWithVersions,
      downloadLowQ,
      downloadLowQWithVersions,
      placement,
      t,
      togglerElement,
    } = this.props;

    return (
      <DropdownList
        placement={placement}
        options={[
          ...(downloadLowQ
            ? [
              {
                action: downloadLowQ,
                name: 'downloadLowQ',
                label: t('components:download_archive_button.low_quality'),
              },
            ]
            : []),
          ...(downloadHighQ
            ? [
              {
                action: downloadHighQ,
                name: 'downloadHighQ',
                label: t('components:download_archive_button.high_quality'),
              },
            ]
            : []),
          ...(downloadLowQWithVersions
            ? [
              {
                action: downloadLowQWithVersions,
                name: 'downloadLowQWithVersions',
                label: t('components:download_archive_button.low_quality_with_versions'),
              },
            ]
            : []),
          ...(downloadHighQWithVersions
            ? [
              {
                action: downloadHighQWithVersions,
                name: 'downloadHighQWithVersions',
                label: t('components:download_archive_button.high_quality_with_versions'),
              },
            ]
            : []),
        ]}
        togglerElement={togglerElement}
      />
    );
  }
}

export default withTranslation('components')(DownloadArchiveButton);
